import { Button } from "@shopify/polaris";

export function CashSubmit({ disabled, onClick }) {
  return (
    <Button primary onClick={onClick} disabled={disabled}>
      Continuar
    </Button>
  );
}
